/**
 * FRANCHISOR_TRIGGER_LABELS — the pt-BR display label for each of the 7
 * franchisor-channels trigger_key values (docs/billing-franchisor-channels.md
 * "Catálogo de triggers"). Single source of truth shared by
 * TriggerMatrixSection (the matrix rows) and ChannelMessagesLog (the log's
 * trigger filter, S13 final-review MINOR 8) so the two never drift.
 *
 * Raw strings here — callers wrap with `t()` at the point of use, same as
 * every other hardcoded pt-BR string in this codebase (mandatory rule #2).
 */
export const FRANCHISOR_TRIGGER_LABELS: Record<string, string> = {
  grace_reminder: 'Lembrete de carência (countdown)',
  subscription_created: 'Assinatura criada',
  grace_started: 'Entrada em carência',
  payment_confirmed: 'Pagamento confirmado (recibo)',
  subscription_cancelled: 'Assinatura cancelada',
  credit_low_balance: 'Saldo de créditos baixo',
  credit_purchase_confirmed: 'Compra de créditos confirmada',
}

/** The 7 keys, in the same order as FRANCHISOR_TRIGGER_LABELS. */
export const FRANCHISOR_TRIGGER_KEYS: string[] = Object.keys(FRANCHISOR_TRIGGER_LABELS)
